import { useContext } from "react";
import { MenuContext } from "./MenuContext";

export function useMenuCtx() {
  return useContext(MenuContext);
}
